import React, {useEffect, useState} from 'react'
import Moment from 'react-moment'
import SweetAlert from 'react-bootstrap-sweetalert'
import {ProjectGuestPortalClient} from '../../infrastracture/api/ProjectGuestPortalClient'

export function ProjectGuestBookings() {
  const [bookings, setBookings] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [toRelease, setToRelease] = useState<any>(null)

  const load = async () => {
    setLoading(true)
    const response = await ProjectGuestPortalClient.GetMyBookings()
    if (response.successful) setBookings(response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
  }, [])

  const handleRelease = async () => {
    if (!toRelease) return
    setError('')
    const response = await ProjectGuestPortalClient.ReleaseCheckIn(toRelease.projectId, toRelease.id)
    setToRelease(null)
    if (response.successful) await load()
    else setError(response.validationErrors?.[0]?.message || 'Failed to release the booking.')
  }

  const handleExtend = async (booking: any) => {
    setError('')
    const response = await ProjectGuestPortalClient.ExtendCheckIn(booking.projectId, booking.id, 60)
    if (response.successful) await load()
    else setError(response.validationErrors?.[0]?.message || 'Failed to extend the booking.')
  }

  const handleEarlyCheckIn = async (booking: any) => {
    setError('')
    const response = await ProjectGuestPortalClient.EarlyCheckIn(booking.projectId, booking.id)
    if (response.successful) await load()
    else setError(response.validationErrors?.[0]?.message || 'Failed to check in early.')
  }

  return (
    <div className='card'>
      <SweetAlert
        warning
        title='Release booking'
        show={!!toRelease}
        onConfirm={handleRelease}
        onCancel={() => setToRelease(null)}
        confirmBtnText='Release'
        cancelBtnBsStyle='light'
        showCancel
        showConfirm
        showCloseButton
      >
        <span>Are you sure you want to release {toRelease?.assetName}?</span>
      </SweetAlert>

      <div className='card-header'>
        <div className='card-title'>
          <h3>My Bookings</h3>
        </div>
      </div>
      {error && (
        <div className='px-9 pt-3'>
          <span className='text-danger'>{error}</span>
        </div>
      )}
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-150px rounded-start'>Project</th>
                <th className='min-w-150px'>Asset</th>
                <th className='min-w-150px'>Date</th>
                <th className='min-w-100px'>Status</th>
                <th className='min-w-250px text-end rounded-end'></th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                bookings.map((booking) => (
                  <tr key={booking.id}>
                    <td className='ps-4'>{booking.projectName}</td>
                    <td>{booking.assetName}</td>
                    <td>
                      {booking.checkInDate && (
                        <Moment utc local format='ddd DD MMM, YYYY'>
                          {booking.checkInDate}
                        </Moment>
                      )}
                    </td>
                    <td>
                      <span className='badge badge-light-primary'>{booking.status}</span>
                    </td>
                    <td className='text-end'>
                      {booking.status === 'Pending' && (
                        <button
                          type='button'
                          className='btn btn-sm btn-light-success me-2'
                          onClick={() => handleEarlyCheckIn(booking)}
                        >
                          Check in now
                        </button>
                      )}
                      <button
                        type='button'
                        className='btn btn-sm btn-light-primary me-2'
                        onClick={() => handleExtend(booking)}
                      >
                        +1 hr
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-light-danger'
                        onClick={() => setToRelease(booking)}
                      >
                        Release
                      </button>
                    </td>
                  </tr>
                ))}
              {!loading && bookings.length === 0 && (
                <tr>
                  <td colSpan={5} className='text-center text-muted py-5'>
                    No upcoming bookings
                  </td>
                </tr>
              )}
              {loading && (
                <tr>
                  <td colSpan={5} className='text-center text-muted py-5'>
                    Loading...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
